import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import work1MainImage from './image/works/work1MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import {MainImage} from './workDetailPage/WorkMainImage';
import BackButton from './components/BackButton';
import { WorkImage } from './workDetailPage/WorkImage';
import { WorkFullImage } from './workDetailPage/WorkFullImage';
import goal from './image/works/work1goal.webp';
import needs from './image/works/work1needs.webp';
import IA from './image/works/work1IA.webp';
import wireframe from './image/works/work1wireframe.webp';
import { Divider } from '@mui/material';
import liteIA from './image/works/work1liteIA.webp';
import ExpertIA from './image/works/work1exportIA.webp';
import NextItem from './components/NextItem';
import thumbnail4 from './image/workThumbnails/thumbnail4.webp';
import feature1 from './image/works/work1feature1.webp';
import feature2 from './image/works/work1feature2.webp';
import feature3 from './image/works/work1feature3.webp';
import feature4 from './image/works/work1feature4.webp';
import feature5 from './image/works/work1feature5.webp';
import feature6 from './image/works/work1feature6.webp';
import direction1 from './image/works/work1direction1.webp';
import direction2 from './image/works/work1direction2.webp';
import design1 from './image/works/work1design1.webp';
import design2 from './image/works/work1design2.webp';
import design3 from './image/works/work1design3.webp';
import design4 from './image/works/work1design4.webp';
import design5 from './image/works/work1design5.webp';
import flowchart from './image/works/work1flowchart.webp';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';
//New Ads Platform for Experts


function Work1(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'New Ads Platform for Experts - Lynkim',
      description: 'An entirely new advertising platform for mid- to large-scale advertisers.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'New Ads Platform for Experts'} 
          description={'An entirely new advertising platform for mid- to large-scale advertisers.'} 
          team={'Karrot(Daangn)'} 
          role={'User Research, Service Planning, UXUI Design'} 
          period={'2022.01. - 2022.08.'}
          titleKo={'전문가용 신규 광고 플랫폼'}
          descriptionKo={'중·대형 광고주를 위한 완전히 새로운 광고 플랫폼을 설계했습니다.'}
          teamKo={'당근마켓(Karrot)'}
          roleKo={'사용자 리서치, 서비스 기획, UXUI 디자인'}
        />
      </div>
      <MainImage image={work1MainImage}/>
      <div style={{backgroundColor: "var(--color-bg-inverse)", display: "flex", flexDirection:'column' }}>
        < WorkTextSection 
          title='Overview'
          description='As the karrot advertisement platform grews continuously, various advertisers began to use it. As a result, the need to develop the platform suited to a variety of advertisers.'
          isWhiteText={true}
          subDescription='당근 광고 플랫폼이 지속적으로 성장하며, 다양한 광고주가 플랫폼을 이용하기 시작했습니다. 그에 따라 점차 플랫폼이 다양한 광고주의 니즈를 포괄할 수 있도록 개선될 필요성이 높아졌습니다.' />
        <div style={{ margin:"auto", maxWidth:"1600px", alignContent: "center", padding: "100px 48px", display: "flex", flexDirection: "column", gap:"150px" }}>   
            <div style={{ display: "flex", flexDirection: "row", gap:"40px"}}>
                <div style={{ display: "flex", flexDirection: "column", gap:"18px" }}>
                    <div className='nurmericIndex'>1</div>
                    <div style={{
                        color: "var(--color-bg-soft)",
                        fontSize: "18px",
                        lineHeight: "140%"
                        }}>We have continuously developed the platform to reflect the diverse needs of users, which has increased the difficulty and complexity of the platform for SMB to use.
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap:"18px" }}>
                    <div className='nurmericIndex'>2</div>
                    <div style={{
                        color: "var(--color-bg-soft)",
                        fontSize: "18px",
                        lineHeight: "140%"
                        }}>There is a need to launch an advanced advertising platform that meets the needs of professional advertisers who advertise over 1 million won per a month.
                    </div>
                </div>
            </div>     
            <WorkImage image={work1chart1} isMaxheight={true} isbottomPadding={false}/>
          </div>
        </div>
        < WorkTextSection 
          title={'Goal'} 
          description={'As our product grew, various advertisers began to use it. As a result, the need to develop a platform suited to a variety of advertisers.'} 
          subDescription='당근 광고 플랫폼이 지속적으로 성장하며, 다양한 광고주가 플랫폼을 이용하기 시작했습니다. 그에 따라 점차 플랫폼이 다양한 광고주의 니즈를 포괄할 수 있도록 개선될 필요성이 높아졌습니다.'
          />
        
        <WorkFullImage image={goal} isBottomMargin={true}/>
        
                        
        < WorkTextSection 
          title={'User Needs'} 
          description={'In order to create an MVP that reflects the needs of advertisers, we find out the needs of target users throungh In-depth interviews.'}
          subDescription={'광고주의 요구를 반영한 MVP를 만들기 위해 타겟 사용자를 대상으로 심층 인터뷰를 진행해 니즈를 파악했습니다.'} 
        />
       <WorkFullImage image={needs} isMargin={true} isBottomMargin={true} isRoundedCorner={true} isShadow={true} isBorder={true}/>
       
       <WorkTextSection 
         title='Design Direction' 
         description='Marketer-friendly UX with detailed performance analysis features for advertising professionals'
         subDescription='전문 광고주를 위해 세부 성과 분석 기능을 제공하면서도 마케터 친화적인 UX를 지향했습니다.'
       />
       <div className={'margin48'} style={{margin:"auto", maxWidth:"1600px", alignContent: "center",  display: "flex", flexDirection: "row", gap:"24px"}}>
       <WorkFullImage image={direction1} isRoundedCorner={true} isShadow={true} isBorder={true}/>
       <WorkFullImage image={direction2} isRoundedCorner={true} isShadow={true} isBorder={true}/>
       </div>
       
      <WorkTextSection 
        title='Information Architecture'
        description='We designed a Information Architecture that users can understand and use key features easily.'
        subDescription='핵심 기능을 쉽게 이해하고 사용할 수 있도록 정보 구조를 설계했습니다.'
        />
       
      <Divider/>
      <WorkFullImage isMargin={false} image={liteIA}/> 
      <Divider/>
      <WorkFullImage isMargin={false} image={ExpertIA}/>              
      <Divider/>
      <div style={{backgroundColor:'var(--color-bg-soft)', paddingBottom:'60px'}}>
        <WorkTextSection 
            title='Wireframe'
            description='Based on the information Architecture, We carefully planned the actual usage environment such as a creating and managing ads.'
            subDescription='설계된 정보 구조를 바탕으로 광고 생성 및 관리 등 실제 사용 환경을 면밀히 기획했습니다.'
            />
          <WorkFullImage isMargin={true} image={wireframe} isRoundedCorner={true} isBottomMargin={true}/>
      </div>
      <WorkTextSection title='Key features'/>
      <div className={'margin48'} style={{margin:"auto", maxWidth:"1600px", alignContent: "center", display: "flex", flexDirection: "column", gap:"12px", marginBottom:'60px'}}>
        <div style={{ display: "flex", flexDirection: "row", gap:"12px"}}>
          <WorkFullImage image={feature1} isRoundedCorner={true} isShadow={true} isBorder={true}/>     
          <WorkFullImage image={feature2} isRoundedCorner={true} isShadow={true} isBorder={true}/>   
          <WorkFullImage image={feature3} isRoundedCorner={true} isShadow={true} isBorder={true}/>       
        </div>
        <div style={{display: "flex", flexDirection: "row", gap:"12px"}}>
          <WorkFullImage image={feature4} isRoundedCorner={true} isShadow={true} isBorder={true}/>     
          <WorkFullImage image={feature5} isRoundedCorner={true} isShadow={true} isBorder={true}/>   
          <WorkFullImage image={feature6} />                              
        </div>
      </div>
      <WorkTextSection title='UXUI Design'/>
      <WorkFullImage image={design1} isBottomMargin={true}/>
      <WorkFullImage image={design2} isBottomMargin={true}/>
     <div style={{backgroundColor:'var(--color-bg-soft)'}}>
        <WorkTextSection 
              title='Personalized UX for each user'
              description='We designed different UX experiences tailored to best suit small business owners and professional marketers.'
              subDescription='소상공인과 전문 마케터 각각에 적합하도록 서로 다른 맞춤형 UX를 설계했습니다.'
              />
        <WorkFullImage image={design3} />
      </div>
      <WorkFullImage image={design4} isBottomMargin={true}/>
      <div style={{backgroundColor:'var(--color-bg-soft)'}}>
        <WorkTextSection 
          title='Managing multiple operators' 
          description='A professional marketer frequently invites and manages a large volume of operators. Unlike the lite mode, it is designed for convenient bulk invitations of operators.'
          subDescription='전문 마케터는 많은 운영자를 자주 초대하고 관리합니다. 라이트 모드와 달리 운영자 대량 초대를 편리하게 지원하도록 설계했습니다.'
        />
        <WorkFullImage image={design5}/>
        <WorkFullImage image={flowchart}/>
      <Divider/>
      </div>
      <WorkTextSection title='Result' 
        description={<div>We conducted a closed beta test targeting mid-to-large advertisers and confirmed <b className='textGradient'>satisfaction with the user-friendly UX</b> through a satisfaction survey. <br/><br/>After the CBT, the service was opened to all users. As a result, mid-to-large advertisers who had previously used the simple ad mode transitioned to the new expert mode ad platform, and with the influx of new mid-to-large advertisers, ad revenue experienced rapid growth.</div>}
        subDescription={<div>중대형 광고주를 대상으로 한 클로즈 베타 테스트를 진행하고 만족도 조사를 통해 <b className='textGradient'>사용자 친화적인 UX에 대한 만족도</b>를 확인했습니다. <br/><br/>CBT 이후 서비스를 전 사용자에게 공개한 결과, 기존에 간단한 광고 모드를 사용하던 중대형 광고주들이 새로운 전문가 모드 광고 플랫폼으로 전환했고, 새로운 중대형 광고주들의 유입과 함께 광고 매출이 급성장했습니다.</div>}
      />
      <BackButton/>
      <NextItem to='/Work4' thumbnail={thumbnail4} nextProjectTitle='Leading More Business Users to Advertising'/>
      <div style={{ height: "400px" }} />

      </>
      // </ProtectedPage>
    )
}

export default Work1;
